import React, { useEffect } from "react";
import NewSideBar from "../../component/mainAdminComponents/newSideBar";
import "../../component/mainAdminComponents/newDash.css";
import Header from "../../component/Header";
import { DeleteQuiz, getAllQuiz,SwitchQuiz } from "../../Redux/action/adminquiz";
import { useDispatch,useSelector } from "react-redux";
import { FaPen, FaLockOpen, FaToggleOn, FaPlus } from "react-icons/fa";
import { GoTrash } from "react-icons/go";
import { ToastContainer } from "react-toastify";
import {HiLockClosed} from "react-icons/hi"


const UpdateQuiz = () => {

    const dispatch = useDispatch();

    useEffect(() => {
       dispatch(getAllQuiz());
    },[])

    const {allQuizzes,allQuizzesLoading,allQuizzeserror} = useSelector(state => state.getadminquizresults)

    console.log(allQuizzes);

    return(
        <>
      <ToastContainer />

        <Header />
        <div className="mainDashBox">
          <div className="sideBOxhai">
            <NewSideBar className="sideContainer" />
          </div>
  
          <div className="bannerBOxhai">
              <h2 style={{textAlign: 'center',width: '100%',margin:'5px auto',fontSize: '38px',fontFamily:'poppins',fontWeight:"400"}}>Quizzes</h2>
          <div className="container-fluid mt-3">
          {allQuizzesLoading ? (
            <div
              className="spinner-border load"
              role="status"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: 40,
                height: 40,
                color: "#06693B",
                fontSize: 15,
              }}
            >
              <span className="visually-hidden"></span>
            </div>
          ) : (
            <div className="row">
              {allQuizzes &&
                allQuizzes.map((e, i) => {
                  return (
                    <div className="col-md-6 py-2" key={i}>
                      <div className="rounded border border-info shadow p-4">
                        <h5 className="color text-decoration-underline">
                         Course Name:  {e?.courseName}  
                        </h5>
                        <p className="fs-5 mt-2">Topic Name: {e?.topicName}</p>
                        <p>Num of Questions: {e?.numOfQuestion}</p>
                        <h6 style={{ textAlign: "left" }}>
                          Duration: {e?.duration}
                        </h6>
                        <div className="bg-light p-3 shadow rounded d-flex justify-content-between">
                          <div>
                            <h5 className="mt-3">
                              Status : {e?.view ? "Open" : "Closed"}
                            </h5>
                          </div>
                          <h4>
                            <button
                            
                              className="btn btn-info shadow"
                              onClick={() => {
                                dispatch(SwitchQuiz(e._id));
                              }}
                            >
                                 {e?.view ? (
<HiLockClosed />
) : (
    <FaLockOpen />
)}
                            </button>
                            <button
                              className="btn btn-danger shadow ml-1"
                              onClick={() => dispatch(DeleteQuiz(e._id))}
                            >
                               
                              <GoTrash />
                            </button>
                          </h4>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
          </div>
          </div>
        </div>
      </>
    )
}

export default UpdateQuiz